import * as React from "react";
import "./ModelSettingsControl.component.css";
import { useInteractionModelsStore } from "../../store/interaction-models.store";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BroadcastToPeerMessage, DeleteModelMessage } from "flavr-common";
import { useTranslation } from "react-i18next";
import { MenuButton } from "../menu-button/MenuButton.component";
import { busService } from "../../../modules/bus";
import { ModelSettingsControlAppearance } from "./ModelSettingsControlTabs/ModelSettingsControlAppearance.component";
import { ModelSettingsControlTransform } from "./ModelSettingsControlTabs/ModelSettingsControlTransform.component";
import { MessageService } from "../../services/message.service";
var ModelSettingsControlTabs;
(function (ModelSettingsControlTabs) {
    ModelSettingsControlTabs[ModelSettingsControlTabs["transform"] = 0] = "transform";
    ModelSettingsControlTabs[ModelSettingsControlTabs["appearance"] = 1] = "appearance";
})(ModelSettingsControlTabs || (ModelSettingsControlTabs = {}));
const connection = busService.connection("ModelSettingsControl");
export function ModelSettingsControl({ minimized, onToggleMinimized }) {
    const [model, setModel] = useState(undefined);
    const [currentTab, setCurrentTab] = useState(ModelSettingsControlTabs.transform);
    const modelStore = useInteractionModelsStore();
    const { t } = useTranslation();
    useEffect(() => {
        setModel(modelStore.models.find((model) => model.helper.getUID() === modelStore.currentModelUID));
    }, [modelStore]);
    const deleteModel = () => {
        if (model) {
            void MessageService.showConfirmationDelete(t("objecteditor:confirm-dialog-delete-model", "Are you sure you want to delete the model {{model}}?", { model: model.helper.getName() }), () => {
                var _a;
                const message = new DeleteModelMessage((_a = model.helper.getUID()) !== null && _a !== void 0 ? _a : 0);
                connection.send(message);
                connection.send(new BroadcastToPeerMessage([message]));
            });
        }
    };
    const createMenuOptions = () => [
        {
            text: t("objecteditor:menu-option-rename", "Rename"),
            onClick: () => { }
        },
        {
            text: t("objecteditor:menu-option-delete", "Delete"),
            onClick: deleteModel
        }
    ];
    const getTabbarTabClasses = (tab) => {
        let result = "model-settings-control-content-tabbar-tab";
        if (currentTab === tab) {
            result += " model-settings-control-content-tabbar-tab-active";
        }
        return result;
    };
    return (React.createElement("div", { className: "model-settings-control" },
        React.createElement("div", { className: "model-settings-control-title" },
            React.createElement(MenuButton, { icon: "ellipsis-v", options: createMenuOptions(), menuPlacement: minimized ? "top-right" : "bottom-right", size: "small" }),
            React.createElement("div", { className: "model-settings-control-title-text" },
                React.createElement("span", null, model === null || model === void 0 ? void 0 : model.helper.getName())),
            React.createElement("button", { className: "icon-button-small model-settings-control-button", onClick: onToggleMinimized, "data-tooltip": minimized ? t("objecteditor:button-maximize-widget-tooltip", "Maximize") : t("objecteditor:button-minimize-widget-tooltip", "Minimize"), "data-tooltip-position": minimized ? "top-right" : "bottom-right" },
                React.createElement(FontAwesomeIcon, { icon: ["fas", minimized ? "angle-double-up" : "angle-double-down"] })),
            React.createElement("button", { className: "icon-button-small", onClick: () => {
                    modelStore.setCurrentModelUID(undefined);
                }, "data-tooltip": t("objecteditor:button-close-widget-tooltip", "Close"), "data-tooltip-position": minimized ? "top-right" : "bottom-right" },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "times"] }))),
        !minimized && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "model-settings-control-content-tabbar" },
                React.createElement("h2", { className: getTabbarTabClasses(ModelSettingsControlTabs.transform), onClick: () => {
                        setCurrentTab(ModelSettingsControlTabs.transform);
                    } }, t("objecteditor:tab-transform", "Transform")),
                React.createElement("h2", { className: getTabbarTabClasses(ModelSettingsControlTabs.appearance), onClick: () => {
                        setCurrentTab(ModelSettingsControlTabs.appearance);
                    } }, t("objecteditor:tab-appearance", "Appearance"))),
            React.createElement("div", { className: "model-settings-control-content" },
                currentTab === ModelSettingsControlTabs.transform && React.createElement(ModelSettingsControlTransform, { connection: connection }),
                currentTab === ModelSettingsControlTabs.appearance && React.createElement(ModelSettingsControlAppearance, { connection: connection }))))));
}
